module.exports = __webpack_public_path__ + "0d08b0ab520c8e79b08fd006725caaf8.png";